import {Component} from 'react';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';


class CreditReportLoanCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            selected: false
        };
    }

    render() {
       let payStatus = "";
       if (this.props.loanInfo.payHistory === "onTime"){
           payStatus = "Paid As Agreed";
       }else{
            payStatus = "Late Payments";
       }
                           
    return <>
        <hr className="modal-divider mb-2" />
       <div className="mt-2 font-weight-bold">{this.props.loanInfo.loanType}</div>
       <div><b>Original Loan Amount: </b>{doubleToStringMonthly(this.props.loanInfo.totLoanAmt)}</div>
       <div><b>Remaining Balance: </b>{doubleToStringMonthly(this.props.loanInfo.remainingBal)}</div>
       <div><b>Monthly Payment: </b>{doubleToStringMonthly(this.props.loanInfo.payment)}</div>
       <div><b>Status: </b>{payStatus}</div>
       <div><b>Payment History: </b>{payStatus}</div>
      

    </>
    }
}

export default CreditReportLoanCard;